import { Capacitor, registerPlugin } from '@capacitor/core'

export interface AtolDiagnosticsInfo {
  platform: string
  sdkInt?: number
  release?: string
  manufacturer?: string
  model?: string
  abis?: string
  appVersion?: string | null
  appVersionCode?: number
  atolServiceInstalled: boolean
  atolServiceVersion?: string | null
  atolServiceVersionCode?: number
  atolServicePackage?: string
  error?: string
}

interface AtolDiagnosticsPlugin {
  getInfo(): Promise<AtolDiagnosticsInfo>
}

const AtolDiagnostics = registerPlugin<AtolDiagnosticsPlugin>('AtolDiagnostics')

/**
 * Диагностика Android-контура ККТ. В web/Electron плагина нет — возвращаем
 * понятное состояние вместо исключения.
 */
export async function getAtolDiagnostics(): Promise<AtolDiagnosticsInfo> {
  if (!Capacitor.isNativePlatform()) {
    return {
      platform: Capacitor.getPlatform(),
      atolServiceInstalled: false,
      error: 'Диагностика доступна только в Android-сборке'
    }
  }
  try {
    return await AtolDiagnostics.getInfo()
  } catch (error) {
    return {
      platform: Capacitor.getPlatform(),
      atolServiceInstalled: false,
      error: error instanceof Error ? error.message : String(error)
    }
  }
}
